import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'ro', // Main language for the target audience
    debug: true,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    
    // Path to load translations from
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    
    // Detect language from these sources
    detection: {
        order: ['querystring', 'cookie', 'localStorage', 'navigator'],
        caches: ['localStorage', 'cookie']
    }
  });

export default i18n;
